import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { api } from "../api/api";
import { generateReceiverKey } from "../screens/component/ReceiverInSendList";
import { UiReceiverBase } from "../api/models";

interface ReceiverAutocompleteProps {
  onFetchFailed: (error: Error) => void;
  selectedReceivers: any[];
  handleReceiverAdd: (receiver: any) => void;
}

const ReceiverAutocomplete: React.FC<ReceiverAutocompleteProps> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const [options, setOptions] = useState<UiReceiverBase[]>([]);
  const loading = open && options.length === 0;

  const [selected, setSelected] = useState<UiReceiverBase | null>(null);

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    api.receiver.getBaseReceivers()
      .then((receivers) => {
        if (active) {
          setOptions(receivers);
        }
      })
      .catch((error: Error) => {
        props.onFetchFailed(error);
      });

    return () => {
      active = false;
    };
  }, [loading, props]);

  return (
    <Autocomplete
      id="receiver"
      style={{ width: 300 }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => generateReceiverKey(option) === generateReceiverKey(value)}
      getOptionLabel={(option) => option.name}
      options={options.sort((a, b) => a.name.localeCompare(b.name))}
      loading={loading}
      getOptionDisabled={(option) => props.selectedReceivers.includes(option)}
      value={selected}
      onChange={(event: React.SyntheticEvent, newValue: UiReceiverBase | null) => {
        setSelected(newValue);
        props.handleReceiverAdd(newValue);
        setSelected(null);
      }}
      clearOnEscape
      renderOption={(renderProps, option) => (
        <Box component="li" {...renderProps} key={generateReceiverKey(option)}>
          {option.name} {option.alternative ? "*" : ""}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select receiver"
          fullWidth
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default ReceiverAutocomplete;
